// Session 55.ag · Membership page — powered by Emergent-managed claimable
// Stripe sandbox. Renders the live catalog from /api/payments/catalog so
// pricing/products edit in Stripe → surface here without a code change.
import { useEffect, useState } from "react";
import AppShell from "../components/AppShell";
import api from "../lib/api";

export default function Membership() {
  const [catalog, setCatalog] = useState([]);
  const [loading, setLoading] = useState(true);
  const [busyKey, setBusyKey] = useState("");
  const [err, setErr] = useState("");

  useEffect(() => {
    api.get("/payments/catalog")
      .then(r => setCatalog(r.data || []))
      .catch(e => setErr(e?.response?.data?.detail || "Failed to load catalog."))
      .finally(() => setLoading(false));
  }, []);

  const buy = async (lookup_key) => {
    setBusyKey(lookup_key); setErr("");
    try {
      const r = await api.post("/payments/checkout", {
        lookup_key,
        origin_url: window.location.origin,
      });
      window.location.href = r.data.checkout_url;
    } catch (e) {
      setErr(e?.response?.data?.detail || "Checkout failed.");
      setBusyKey("");
    }
  };

  const formatAmount = (p) =>
    `$${p.amount.toFixed(p.amount % 1 ? 2 : 0)} ${p.interval ? `/${p.interval}` : "· one-time"}`;

  return (
    <AppShell>
      <div className="m-page-pad" data-testid="membership-page">
        <span className="m-eyebrow">Membership</span>
        <h1 className="m-h1">Join <em>Métier</em></h1>
        <p className="m-muted" style={{maxWidth:640, marginTop:4}}>
          Founding members unlock early venue drops, priority booking, and members-only events. Pick a plan below to check out securely with Stripe.
        </p>

        {err && <div style={{background:"#FDEDED", border:"1px solid #E5A0A0", padding:"10px 14px", borderRadius:8, marginTop:16, fontSize:13}} data-testid="membership-error">{err}</div>}

        {loading ? (
          <div style={{marginTop:32, color:"rgba(27,35,64,0.5)"}}>Loading catalog…</div>
        ) : (
          <div style={{marginTop:28, display:"grid", gridTemplateColumns:"repeat(auto-fit, minmax(280px, 1fr))", gap:18}}>
            {catalog.map(product => (
              <div key={product.product_id}
                data-testid={`membership-card-${product.product_id}`}
                style={{background:"#FAF8F3", border:"1px solid rgba(184,145,58,0.32)", borderRadius:14, padding:"22px 24px", display:"flex", flexDirection:"column", gap:10}}>
                <div style={{fontSize:11, letterSpacing:"0.14em", textTransform:"uppercase", color:"#B8913A", fontWeight:600}}>Plan</div>
                <h3 style={{fontFamily:"Cormorant Garamond, serif", fontSize:26, margin:0, fontWeight:500, color:"#1B2340"}}>{product.name.replace("Métier · ", "")}</h3>
                <p style={{fontSize:14, color:"rgba(27,35,64,0.75)", lineHeight:1.5, margin:0, minHeight:60}}>{product.description}</p>
                <div style={{marginTop:8, display:"flex", flexDirection:"column", gap:10}}>
                  {product.prices.map(p => (
                    <button key={p.lookup_key} type="button"
                      onClick={() => buy(p.lookup_key)}
                      disabled={!!busyKey}
                      data-testid={`membership-buy-${p.lookup_key}`}
                      style={{padding:"12px 18px", background: busyKey === p.lookup_key ? "rgba(184,145,58,0.5)" : "#B8913A", color:"#FAF8F3", border:"none", borderRadius:999, fontSize:14, fontWeight:500, cursor: busyKey ? "not-allowed" : "pointer", textAlign:"left", display:"flex", justifyContent:"space-between", alignItems:"center"}}>
                      <span>{p.interval ? `${p.interval.charAt(0).toUpperCase()}${p.interval.slice(1)}ly` : "Buy now"}</span>
                      <span style={{fontFamily:"ui-monospace, monospace", fontSize:13}}>{formatAmount(p)}</span>
                    </button>
                  ))}
                </div>
              </div>
            ))}
          </div>
        )}

        <div style={{marginTop:32, fontSize:12, color:"rgba(27,35,64,0.5)"}}>
          Payments are handled by Stripe. Test card: <code>4242 4242 4242 4242</code>, any future expiry, any CVC.
        </div>
      </div>
    </AppShell>
  );
}
